import React from 'react'
import Toast from '../../containers/Toast'
import { ToastAction } from '../../reducers/toasts/actionNames'
import { IToast } from './fireToast'

const fireToastWarning = (
  message: string | React.ReactNode,
  delayClose: number | false = 5000,
  container = 'Main',
  toastId: string | number = undefined,
  withButton = false,
  buttonLabel = '',
  buttonCb: () => void = null,
  buttonIcon: any = null,
  disabled: boolean = true,
): IToast<ToastAction.FireToastWarning> => ({
  container,
  delayClose,
  message: (
    <Toast.Warning
      buttonIcon={buttonIcon}
      withButton={withButton}
      buttonLabel={buttonLabel}
      buttonCb={buttonCb}
      disabled={disabled}
    >
      {message}
    </Toast.Warning>
  ),
  toastId: toastId ? toastId : (message as string),
  type: ToastAction.FireToastWarning,
})

export default fireToastWarning
